import { useState, useEffect } from 'react';
import { IQuestionnaire } from '../types/questionnaire';
import { FormBuilderService } from '../api/FormBuilderService';

export const useQuestionnaireManagement = (companyId: number | null, userId: number | null) => {
  const [questionnaires, setQuestionnaires] = useState<IQuestionnaire[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchQuestionnaires = async () => {
      try {
        if (!companyId) {
          setError('Company ID not found');
          setLoading(false);
          return;
        }
        const response = await FormBuilderService.getQuestionnairesByCompanyId(companyId.toString());
        setQuestionnaires(response);
        setLoading(false);
      } catch (err: any) {
        if(err.status !== 404){
          console.error("Error fetching questionnaires:", err);
        }else{
          console.warn("No questionnaires found for this company");
        }
        setLoading(false);
      }
    };

    fetchQuestionnaires();
  }, [companyId, userId]);

  const handleStatusChange = async (questionnaireId: string, newStatus: boolean) => {
    try {
      if (!companyId) {
        setError('Company ID not found');
        return;
      }

      if(newStatus) {
        await FormBuilderService.patchQuestionnaire(questionnaireId, { active: true });
      } else {
        await FormBuilderService.deactivateQuestionnaireStatus(questionnaireId, newStatus, companyId.toString());
      }

      // Update the local state to reflect the change
      setQuestionnaires(prevQuestionnaires => 
        prevQuestionnaires.map(q => 
          q.questionnaireId === questionnaireId 
            ? { ...q, active: newStatus }
            : q
        )
      );
    } catch (err) {
      console.error('Error updating questionnaire status:', err);
      setError('Failed to update questionnaire status');
    }
  };

  return {
    questionnaires,
    loading,
    error,
    setError,
    handleStatusChange
  };
}; 